// extracted by mini-css-extract-plugin
export default {"container":"Actividad_container__oVmxt","inconformidad_title":"Actividad_inconformidad_title__RgJHd","btnContainer":"Actividad_btnContainer__Wd-vs","btn":"Actividad_btn__SGVnM"};